// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  BillingAccountGetPolicyOptionalParams,
  BillingAccountGetPolicyResponse,
} from "../models/index.js";

/** Interface representing a BillingAccount. */
export interface BillingAccount {
  /**
   * Get Billing Account Policy.
   * @param billingAccountId Billing Account Id.
   * @param options The options parameters.
   */
  getPolicy(
    billingAccountId: string,
    options?: BillingAccountGetPolicyOptionalParams,
  ): Promise<BillingAccountGetPolicyResponse>;
}
